import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createRule, editQuery, setLocation } from "../../../../../actions/queryBuilderActions";
import Modal from "../../../../UIComponents/CustomModal/Modal";
import "./LocationPopupModal.scss";

import CountryDropDown from "../utils/countryDropDown/CountryDropDown";
import { toast } from "react-toastify";

const LocationPopupModal = ({ open, onCancel, queryToEdit }) => {
    const selectedCountryOptions = useSelector((state) => state.queryBuilderReducer.selectedCountryOptions);
    const company_identifier = useSelector((state) => state.globalReducer.company.company_identifier);
    const user_id = useSelector((state) => state.globalReducer.company.user_id);
    const dropdownRef = useRef();
    // const queryList = useSelector((state) =>
    //     state.queryBuilderReducer.createdQueryList.filter((account) => !["competitor", "opa"].includes(account?.config_source?.toLowerCase())),
    // );

    const dispatch = useDispatch();
    useEffect(() => {
        if (selectedCountryOptions.length == 1 && selectedCountryOptions[0]?.label === "Worldwide") selectedCountryOptions.pop();
        dropdownRef.current.focus();
    }, []);

    useEffect(() => {
        dispatch(editQuery(queryToEdit));
        // console.log("queryToEdit", queryToEdit);
    }, [queryToEdit]);

    const handleCountryChange = (selectedCountryOptions) => {
        let countryList = [];
        countryList = selectedCountryOptions.map((ele) => ele.label);
        if (countryList.includes("Worldwide")) {
            dispatch(setLocation([selectedCountryOptions[selectedCountryOptions.length - 1]]));
        } else {
            dispatch(setLocation(selectedCountryOptions));
        }
    };

    const clearEditQuery = () => {
        dispatch(editQuery({}));
        onCancel();
    };

    const updateQuery = () => {
        //     const slectedTopicName = this.props.selectedTopic;
        //     const newTopicName = this.props.newTopicName;
        //     const subTopicName = this.props.subTopicName.trim();
        //     const booleanValue = this.props.booleanValue;
        let selectedLocations = selectedCountryOptions;
        let slectedLocationString = "";
        if (selectedLocations.map((ele) => ele.short_name).includes("Worldwide")) {
            slectedLocationString = "";
        } else {
            slectedLocationString = selectedLocations.map((ele) => ele.short_name).join();
        }

        let query = queryToEdit;

        // const slectedTopicName = query.topic_name;
        // const newTopicName = this.props.newTopicName;
        const subTopicName = query.subtopic_name?.trim();
        const booleanValue = query.boolean;

        const param = {};
        param["accounts"] = 1;
        param["boolean_query"] = booleanValue.replaceAll("\n", "");
        param["company_identifier"] = company_identifier;
        param["countries"] = slectedLocationString;
        param["data_fetch_enabled"] = 1;
        param["graph_color"] = query.graph_color;
        //     param["graph_color"] = slectedTopicName && Object.keys(slectedTopicName).length > 0 ? this.props.selectedTopicColor : this.props.newTopicColor;
        //     param["name"] = slectedTopicName?.label || newTopicName;
        param["name"] = query.topic_name;
        param["status"] = "Active";
        param["subtopic"] = query.subtopic_name;
        //     param["subtopic_graph_color"] = this.props.subTopicColor;
        param["subtopic_graph_color"] = query.subtopic_graph_color;
        param["twitter_stream_query"] = "";
        param["user_id"] = String(user_id);
        param["accountList"] = [];
        //     param["accountList"] = uniqueUpdatedAccounts;
        //     if (Object.keys(queryInfo).length > 0) {
        param["id"] = query.research_query_id;
        param["subtopic_id"] = query.subtopic_id;
        //         // this.props.editQuery({});
        //     }
        //     this.props.createRule(param);
        dispatch(createRule(param));
    };

    const valdiateCountries = () => {
        if (selectedCountryOptions.length < 1) toast.error("please select countries");
        else {
            updateQuery();
            clearEditQuery();
            // toast.success("You have been upgraded to receive full data for all your listening queries");
        }
    };
    return (
        // <div>LocationPopupModal</div>;
        <Modal className="tkModal location__update__container" show={open} onClose={clearEditQuery}>
            <Modal.Header className="">Location</Modal.Header>
            <Modal.Content className="location__update__modal">
                <p className="tkModalHeader">Select the Locations that you want to track</p>
                {/* <p className="tkModalHeader">Please Note: Different permission cannot be provided for different pages under the same account</p> */}
                <CountryDropDown
                    selectedCountryOptions={selectedCountryOptions}
                    // isDisabled={true}
                    menuIsOpen={true}
                    handleCountryChange={handleCountryChange}
                    popupModal={true}
                    innerRef={dropdownRef}
                />
            </Modal.Content>
            <Modal.Actions>
                <div className="buttonsSection">
                    <div className="buttons">
                        <Modal.ActionButton
                            normal
                            onClick={() => {
                                clearEditQuery();
                            }}>
                            Cancel
                        </Modal.ActionButton>
                        <Modal.ActionButton
                            filled
                            onClick={() => {
                                valdiateCountries();
                            }}>
                            Add location
                        </Modal.ActionButton>
                    </div>
                </div>
            </Modal.Actions>
        </Modal>
    );
};

export default LocationPopupModal;
